/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2020, Zumper
 * @description multifamilyTourTimePicker actions
 */

import type { SerializableDate, TourAvailability, TourIntegrationNonEmpty } from '@zcode/bizos'
import type { IntegratedTourType } from '@zcode/enums'
import { createAction } from 'redux-actions'
import {
  DONE_SUBMITTING,
  ERROR_FETCHING_TOUR_AVAILABILITY,
  ERROR_FETCHING_TOUR_INTEGRATION,
  RECEIVE_SELECTED_DATETIME,
  RECEIVE_SELECTED_TOUR_TYPE,
  RECEIVE_TOUR_AVAILABILITY,
  RECEIVE_TOUR_INTEGRATION,
  RESET_SELECTED_DATETIME,
  START_FETCHING_TOUR_AVAILABILITY,
  START_FETCHING_TOUR_INTEGRATION,
  START_SUBMITTING,
} from '../constants/index'

export const errorFetchingTourAvailability = createAction<
  { readonly groupId: number; readonly type: IntegratedTourType },
  typeof ERROR_FETCHING_TOUR_AVAILABILITY
>(ERROR_FETCHING_TOUR_AVAILABILITY)
export const receiveTourAvailability = createAction<
  { readonly availability: TourAvailability; readonly groupId: number },
  typeof RECEIVE_TOUR_AVAILABILITY
>(RECEIVE_TOUR_AVAILABILITY)
export const startFetchingTourAvailability = createAction<
  { readonly groupId: number; readonly type: IntegratedTourType },
  typeof START_FETCHING_TOUR_AVAILABILITY
>(START_FETCHING_TOUR_AVAILABILITY)

export const errorFetchingTourIntegrationForGroupId = createAction<
  number,
  typeof ERROR_FETCHING_TOUR_INTEGRATION
>(ERROR_FETCHING_TOUR_INTEGRATION)
export const receiveTourIntegration: (
  payload: TourIntegrationNonEmpty | /** groupId: */ number
) => {
  readonly payload: TourIntegrationNonEmpty | /** groupId: */ number
  readonly type: typeof RECEIVE_TOUR_INTEGRATION
} = createAction<TourIntegrationNonEmpty | /** groupId: */ number, typeof RECEIVE_TOUR_INTEGRATION>(
  RECEIVE_TOUR_INTEGRATION
)
export const startFetchingTourIntegrationForGroupId = createAction<
  number,
  typeof START_FETCHING_TOUR_INTEGRATION
>(START_FETCHING_TOUR_INTEGRATION)

export const receiveSelectedDatetime = createAction<
  Date | SerializableDate | null,
  typeof RECEIVE_SELECTED_DATETIME
>(RECEIVE_SELECTED_DATETIME)
export const resetSelectedDatetime = createAction(RESET_SELECTED_DATETIME)
export const receiveSelectedTourType = createAction<
  IntegratedTourType,
  typeof RECEIVE_SELECTED_TOUR_TYPE
>(RECEIVE_SELECTED_TOUR_TYPE)
export const startSubmitting = createAction(START_SUBMITTING)
export const doneSubmitting = createAction(DONE_SUBMITTING)
